import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { BillingGroupsContainer } from '@/features/billing-groups/containers';
import { meilisearchSearchSchema } from '@/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/billing-groups/')({
  component: BillingGroupsContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
